module.exports = __webpack_public_path__ + "f6db07fcb106e57a29ac8f6adb886206.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/partials/bao-mat-thanh-toan.jpg
// module id = ./assets/images/partials/bao-mat-thanh-toan.jpg
// module chunks = 0